/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedRequestHold_item$ref = any;
export type PdpSharedRequestHold_item = {
    readonly hasRequestedHoldForBuyer?: boolean | null;
    readonly displayInfo?: {
        readonly ctas: {
            readonly showHoldRequest: boolean | null;
        } | null;
    } | null;
    readonly " $refType": PdpSharedRequestHold_item$ref;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
};
return {
  "kind": "Fragment",
  "name": "PdpSharedRequestHold_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "isClient",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isClient",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasRequestedHoldForBuyer",
          "args": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "displayInfo",
          "storageKey": null,
          "args": [
            (v0/*: any*/),
            {
              "kind": "Literal",
              "name": "page",
              "value": "pdp"
            }
          ],
          "concreteType": "ItemDisplayInfo",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "ctas",
              "storageKey": null,
              "args": null,
              "concreteType": "CTADisplay",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "showHoldRequest",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '18408e7f3b715ed1fc7463fb1db5317f';
export default node;
